module.exports = __webpack_public_path__ + "media/pages/assets/images/bus-1622a2586e87252c9aace89c354eefed.svg";